import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type RF} from '../factory';
import EntityFactory from '../factory/famly-app';
import Model from './child-plans-behaviors-model';

export default EntityFactory.createEntity<
    {id: string; behaviors: BehaviorsCollection},
    RF<{id: string; behaviors: BehaviorsCollection}>,
    unknown
>({
    domain: 'ENTITIES/CHILD_PLAN_BEHAVIORS',
    entityName: '',
    model: Model,
    // this was not provided at all in the js version, so adding this
    // when moving to ts to fix type errors
    apiDescription: {},
});
